import React from 'react'
import Button from '../uiKit/Button'
import SectionMarker from '../uiKit/SectionMarker'
import StaticQuestionSlide from '../slides/StaticQuestionSlide'

class LiveViewNotification extends React.Component{

	render(){	
		const {control,section}=this.props
		// let isSet=false
		// //let setTitle=''
		// if(setPoll){
		// 	isSet=true
		// 	// if(setPoll.snapshot){
		// 	// 	setTitle=setPoll.snapshot.name
		// 	// }
		// }

		// let sectionColor=''
		// if(section){
		// 	sectionColor=section.color
		// }

		const activeCountdown = true
		const activeCountdownSeconds = this.props.seconds

		return(
			<div className='liveViewNotificationContainer'>
				<div className='liveViewNotification'>
					
					{section && 
						<div className='liveViewNotification-live'>
							Live
							<SectionMarker type={'colorOnly'} label='Live' section={section} />
						</div>
					}

					{section &&
						<div className='liveViewNotification-sectionName'>
							{section.name}
						</div>
					}

					<div className='liveViewNotification-slidePreview' onClick={this.props.showLiveViewModal}>
							
						<StaticQuestionSlide 
							question={control.snapshot} 
							displayWidth={350} 
						/>

						{activeCountdown && activeCountdownSeconds > 0 &&
							<div className='liveViewNotification-slidePreview-countDown'>								
								{activeCountdownSeconds}
								<div className='liveViewNotification-slidePreview-container-spinnerContainer'>
									<div className='liveViewNotification-slidePreview-container-spinner' />
								</div>
							</div>
						}

					</div> 

					<div className='liveViewNotification-actionRow'>
						<Button label='Open Now' onClickFunction={this.props.showLiveViewModal} color='blue' labelColor='light' />
						<Button label='Ignore' onClickFunction={this.props.hideLiveViewNotification} />
					</div>

				</div>
								
			</div>
		)
	}
				
}






export default LiveViewNotification





// WEBPACK FOOTER //
// ./src/components/liveView/LiveViewNotification.js